<template>
  <v-col cols="12">
    <div class="my-3"
         v-if="selected.length > 0">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="success"
                 dark
                 v-bind="attrs"
                 v-on="on"
                 rounded
                 small
                 class="ml-2">
            <span class="font-weight-bold">Download</span>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item>
            <v-list-item-title>
              <json-excel type="xls"
                          :data="selected"
                          name="Experimentally_supported_AS_events.xls">
                <v-btn text
                       block> <span class="font-weight-bold">xls</span> </v-btn>
              </json-excel>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <json-excel type="csv"
                          :data="selected"
                          name="Experimentally_supported_AS_events.csv">
                <v-btn text
                       block> <span class="font-weight-bold">csv</span> </v-btn>
              </json-excel>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-expansion-panels class="data-table-style">
      <v-expansion-panel>
        <v-expansion-panel-header expand-icon="mdi-menu-down"
                                  style="padding: 10px 25px">
          <div class="d-flex font-weight-bold">
            <span class="blue--text font-weight-bold mt-1">Display Columns</span>
            <v-chip outlined
                    small
                    color="success"
                    class="ml-2"
                    @click="showAll()">
              Select All
            </v-chip>
            <v-chip outlined
                    small
                    color="error"
                    class="ml-2"
                    @click="showDefault()">
              Select Default
            </v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="v-item-group">
            <v-checkbox v-for="(header, index) in headers"
                        :key="index"
                        :label="header.text"
                        :value="header.text"
                        v-model="selectedHeader"
                        dense
                        class="mx-1"></v-checkbox>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-data-table dense
                  class="data-table-style mt-1"
                  :headers="selectedHeaders"
                  fixed-header
                  :items="spliceVariant"
                  v-model="selected"
                  item-key="_id"
                  :search="search"
                  show-select
                  :single-select="singleSelect"
                  :loading="loading"
                  loading-text="Loading... Please wait"
                  :page.sync="currentPage"
                  hide-default-footer
                  :items-per-page="pageSize">
      <!-- item.event_id slot -->
      <template v-slot:[`item.event_id`]="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs"
                  v-on="on">{{item.event_id}}</span>
          </template>
          <span><span class="error--text font-weight-bold">Event ID: </span> Gene _ Chromsome _ Strand _ AS Type _ Event Coordinates</span>
        </v-tooltip>
      </template>
      <!-- item.as_model_id slot -->
      <template v-slot:[`item.as_model_id`]="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs"
                  v-on="on">{{item.as_model_id}}</span>
          </template>
          <span><span class="error--text font-weight-bold">AS Model ID: </span>Gene _ Chromsome _ Strand _ AS Type _ AS Model Coordinates</span>
        </v-tooltip>
      </template>
      <!-- item.gene_name slot -->
      <template v-slot:[`item.gene_name`]="{item}">
        <a @click="goToGeneSearchResult(item.gene_name)"> <span class="font-weight-bold">{{item.gene_name}}</span>
        </a>
      </template>

      <!-- item.cancer_name slot -->
      <template v-slot:[`item.cancer_name`]="{item}">
        <span v-if="!item.cancer_name.includes(',')">{{item.cancer_name}}</span>
        <v-tooltip bottom
                   v-else>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs"
                  v-on="on">{{item.cancer_name.split(', ')[0]}} ...</span>
          </template>
          <span>{{item.cancer_name}}</span>
        </v-tooltip>
      </template>

      <!-- header.methods slot -->
      <template v-slot:[`header.methods`]="{header}">
        {{header.text}}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    v-bind="attrs"
                    v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>existent: <v-icon small
                    color="success">mdi-check-circle-outline</v-icon><br>non-existent: <v-icon small
                    color="error">mdi-close-circle-outline</v-icon></span>
        </v-tooltip>
      </template>

      <!-- header.regulatory_mechanism slot -->
      <template v-slot:[`header.regulatory_mechanism`]="{header}">
        {{header.text}}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    v-bind="attrs"
                    v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>existent: <v-icon small
                    color="success">mdi-check-circle-outline</v-icon><br>non-existent: <v-icon small
                    color="error">mdi-close-circle-outline</v-icon></span>
        </v-tooltip>
      </template>

      <!-- header.biological_function slot -->
      <template v-slot:[`header.biological_function`]="{header}">
        {{header.text}}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    v-bind="attrs"
                    v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>existent: <v-icon small
                    color="success">mdi-check-circle-outline</v-icon><br>non-existent: <v-icon small
                    color="error">mdi-close-circle-outline</v-icon></span>
        </v-tooltip>
      </template>

      <!-- header.regulatory_network slot -->
      <template v-slot:[`header.regulatory_network`]="{header}">
        {{header.text}}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    v-bind="attrs"
                    v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Splicing Regulatory Network</span>
        </v-tooltip>
      </template>

      <!-- header.regulatory_explorer slot -->
      <template v-slot:[`header.regulatory_explorer`]="{header}">
        {{header.text}}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    v-bind="attrs"
                    v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Splicing Regulatory Explorer</span>
        </v-tooltip>
      </template>

      <!-- header.survival slot -->
      <template v-slot:[`header.survival`]="{header}">
        {{header.text}}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    v-bind="attrs"
                    v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Survival Analysis</span>
        </v-tooltip>
      </template>

      <!-- header.staging slot -->
      <template v-slot:[`header.staging`]="{header}">
        {{header.text}}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    v-bind="attrs"
                    v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Cancer Staging Analysis</span>
        </v-tooltip>
      </template>

      <!-- item.methods slot -->
      <template v-slot:[`item.methods`]="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs"
                  v-on="on">
              <v-icon v-if='item.methods !== ("" || "-" || "NA")'
                      color="success">mdi-check-circle-outline</v-icon>
              <v-icon v-else
                      color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <span>{{item.methods}}</span>
        </v-tooltip>
      </template>

      <!-- item.regulatory_mechanism slot -->
      <template v-slot:[`item.regulatory_mechanism`]="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs"
                  v-on="on">
              <v-icon v-if='item.regulatory_mechanism !== ("" || "-" || "NA")'
                      color="success">mdi-check-circle-outline</v-icon>
              <v-icon v-else
                      color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <span>{{item.regulatory_mechanism}}</span>
        </v-tooltip>
      </template>

      <!-- item.biological_function slot -->
      <template v-slot:[`item.biological_function`]="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs"
                  v-on="on">
              <v-icon v-if='item.biological_function !== ("" || "-" || "NA")'
                      color="success">mdi-check-circle-outline</v-icon>
              <v-icon v-else
                      color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <span>{{item.biological_function}}</span>
        </v-tooltip>
      </template>

      <!-- item.pubmed_id slot -->
      <template v-slot:[`item.pubmed_id`]="{item}">
        <a :href="pubmedLink+item.pubmed_id"
           target="_blank">{{item.pubmed_id}}</a>
      </template>

      <!-- item.title slot -->
      <template v-slot:[`item.title`]="{item}">
        <span v-if="item.title.length <= 100">{{item.title}}</span>
        <v-tooltip bottom
                   v-else>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs"
                  v-on="on">{{item.title.slice(0, 100) + '...'}}</span>
          </template>
          <span>{{item.title}}</span>
        </v-tooltip>
      </template>

      <!-- item.visualization slot -->
      <template v-slot:[`item.visualization`]="{item}">
        <v-btn @click="goToVisualiztion(item.gene_name, item.as_type, item.event_coordinates)"
               color="info"
               icon
               :disabled="['Complex', 'AF', 'AL'].includes(item.as_type)">
          <v-icon>mdi-tune</v-icon>
        </v-btn>
      </template>

      <!-- item.regulatory_network slot -->
      <template v-slot:[`item.regulatory_network`]="{item}">
        <v-btn @click="goToRegulationNetwork(item.gene_name)"
               color="info"
               icon>
          <svg class="icon"
               aria-hidden="true">
            <use xlink:href="#icon-icon-copy"></use>
          </svg>
        </v-btn>
      </template>

      <!-- item.regulatory_explorer slot -->
      <template v-slot:[`item.regulatory_explorer`]="{item}">
        <v-btn @click="goToRegulationExplorer(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
               color="grey"
               icon
               :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
          <svg class="icon"
               aria-hidden="true"
               v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
            <use xlink:href="#icon-GridView-diable"></use>
          </svg>
          <svg class="icon"
               aria-hidden="true"
               v-else>
            <use xlink:href="#icon-GridView-oncoprint"></use>
          </svg>
        </v-btn>
      </template>

      <!-- item.survival slot -->
      <template v-slot:[`item.survival`]="{item}">
        <v-btn @click="goToSurvival(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
               color="info"
               icon
               :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !survival_project_items.includes(item.tcga_project_id)">
          <svg class="icon"
               aria-hidden="true"
               v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !survival_project_items.includes(item.tcga_project_id)">
            <use xlink:href="#icon-linechart-diable"></use>
          </svg>
          <svg class="icon"
               aria-hidden="true"
               v-else>
            <use xlink:href="#icon-linechart"></use>
          </svg>
        </v-btn>
      </template>

      <!-- item.staging slot -->
      <template v-slot:[`item.staging`]="{item}">
        <v-btn @click="goToStaging(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
               color="info"
               icon
               :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !stage_project_items.includes(item.tcga_project_id)">
          <svg class="icon"
               aria-hidden="true"
               v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !stage_project_items.includes(item.tcga_project_id)">
            <use xlink:href="#icon-xiangxiantu-disable"></use>
          </svg>
          <svg class="icon"
               aria-hidden="true"
               v-else>
            <use xlink:href="#icon-xiangxiantu"></use>
          </svg>
        </v-btn>
      </template>

      <!-- item.details slot -->
      <template v-slot:[`item.details`]="{item}">
        <v-btn @click="goToDetails(item.event_id, item.cancer_name, item.pubmed_id)"
               color="info"
               icon>
          <v-icon>mdi-chevron-right-circle</v-icon>
        </v-btn>
      </template>

      <!-- header.data-table-select slot-->
      <template v-slot:[`header.data-table-select`]="{ on, props }">
        <v-simple-checkbox color="success"
                           v-bind="props"
                           v-on="on"></v-simple-checkbox>
      </template>

      <!-- item.data-table-select slot -->
      <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
        <v-simple-checkbox color="info"
                           :value="isSelected"
                           @input="select($event)"></v-simple-checkbox>
      </template>
    </v-data-table>

    <div class="d-flex justify-center mt-2 mb-n10">
      <span class="text-body-1 mt-3">Items per page</span>
      <v-select v-model="pageSize"
                dense
                outlined
                :items="pageSizes"
                class="pagesize-select mt-1 mx-2"
                @input="handlePageSizeChange(pageSize)">
      </v-select>
      <span class="text-body-1 mt-3 mx-2">Total <span class="font-weight-bold info--text">{{totalItems}}</span>
        items </span>
      <v-pagination v-model="currentPage"
                    color="info"
                    :length="totalPages"
                    :total-visible="8"
                    class="mx-1"
                    @input="handlePageChange"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right">
      </v-pagination>
      <span class="text-body-1 mt-2 mx-2">Page</span>
      <v-text-field outlined
                    dense
                    v-model="whichPage"
                    type="number"
                    class="jump-select"
                    append-icon="">
      </v-text-field>
      <v-btn color=""
             depressed
             outlined
             class="mx-2"
             @click="jumpPage()">Jump</v-btn>
    </div>
  </v-col>

</template>

<script>
import { getSpliceKnowledge } from 'node/browse';
import JsonExcel from 'vue-json-excel';
export default {
  name: 'KnowledgeResultByGene',
  components: {
    JsonExcel
  },
  data() {
    return {
      search: '',
      selected: [],
      singleSelect: false,
      loading: true,
      pubmedLink: 'https://pubmed.ncbi.nlm.nih.gov/',
      currentPage: 1,
      whichPage: 1,
      totalPages: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 50, 100],
      totalItems: 0,
      selectedHeader: ['Gene Name', 'Cancer Type', 'AS Type',
        'ORF', 'Mechanism', 'Function', 'PubMed', 'Visualization',
        'Network', 'Explorer', 'Survival', 'Staging', 'Details'],
      headers: [
        { text: 'Event ID', value: 'event_id', align: 'start', sortable: false, },
        { text: 'AS Model ID', value: 'as_model_id', align: 'start', sortable: false, },
        { text: 'Gene Name', value: 'gene_name', align: 'start', sortable: true, },
        { text: 'Ensembl ID', value: 'ensembl_id', align: 'start', sortable: true, },
        { text: 'Chromsome', value: 'chr', align: 'start', sortable: false, },
        { text: 'Strand', value: 'strand', align: 'start', sortable: false, },
        { text: 'Cancer Type', value: 'cancer_name', align: 'start', sortable: true },
        { text: 'Canonical Transcript', value: 'ct_ensembl_id', align: 'start', sortable: false, },
        { text: 'Splicing Variant', value: 'sv_ensembl_id', align: 'start', sortable: false, },
        { text: 'AS Type', value: 'as_type', align: 'start', sortable: true, },
        { text: 'Event Coordinates', value: 'event_coordinates', align: 'start', sortable: false, },
        { text: 'Alt Coordinates', value: 'alt_coordinates', align: 'start', sortable: false, },
        // { text: 'Splice In Isoforms', value: 'splice_in_isoforms', align: 'start', sortable: false, },
        // { text: 'Splice Out Isoforms', value: 'splice_out_isoforms', align: 'start', sortable: false, },
        { text: 'ORF', value: 'orf_annotation', align: 'start', sortable: false, },
        { text: 'Method', value: 'methods', align: 'center', sortable: false, },
        { text: 'Mechanism', value: 'regulatory_mechanism', align: 'center', sortable: false, },
        { text: 'Function', value: 'biological_function', align: 'center', sortable: false, },
        { text: 'Primary Site', value: 'primary_site', align: 'start', sortable: false, },
        { text: 'Year', value: 'year', align: 'start', sortable: true, },
        { text: 'PubMed', value: 'pubmed_id', align: 'start', sortable: false, },
        { text: 'Journal', value: 'journal', align: 'start', sortable: false, },
        { text: 'Title', value: 'title', align: 'start', sortable: false, },
        { text: 'Visualization', value: 'visualization', align: 'center', sortable: false, },
        { text: 'Network', value: 'regulatory_network', align: 'center', sortable: false, },
        { text: 'Explorer', value: 'regulatory_explorer', align: 'center', sortable: false, },
        { text: 'Survival', value: 'survival', align: 'center', sortable: false, },
        { text: 'Staging', value: 'staging', align: 'center', sortable: false, },
        { text: 'Details', value: 'details', align: 'center', sortable: false, },
      ],

      gene_select: null,

      spliceVariant: [],

      survival_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
        "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO",
        "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD", "TCGA-READ", "TCGA-SARC",
        "TCGA-SKCM", "TCGA-STAD", "TCGA-THCA", "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      ],
      stage_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-ESCA", "TCGA-HNSC", "TCGA-KICH", "TCGA-KIRC", "TCGA-KIRP",
        "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO", "TCGA-PAAD", "TCGA-READ", "TCGA-SKCM",
        "TCGA-STAD", "TCGA-THCA",
      ],
    }
  },
  props: {
    geneName: {
      type: String,
      default() {
        return
      }
    }
  },
  created() {
  },
  watch: {
    spliceVariant(val) {
      if (val) {
        this.loading = false;
      }
    },
    geneName(newVal, oldVal) {
      //   console.log(newVal);
      this.gene_select = newVal;
      this.getSpliceKnowledge();
    }
  },
  computed: {
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    },
  },
  methods: {
    getRequestParams(genename, page, pageSize) {
      let params = {};
      if (genename) {
        params["genename"] = genename;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    async getSpliceKnowledge() {
      this.loading = true;
      const params = this.getRequestParams(
        this.gene_select,
        this.currentPage,
        this.pageSize
      );
      await getSpliceKnowledge(params).then((data) => {
        // console.log(data);
        this.loading = false;
        this.totalItems = data.totalItems;
        this.spliceVariant = data.items;
        this.currentPage = data.currentPage;
        this.totalPages = data.totalPages;
      }).catch((err) => {
        console.error(err);
      });
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.whichPage = this.currentPage;
      this.getSpliceKnowledge();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getSpliceKnowledge();
    },
    jumpPage() {
      // console.log(+this.whichPage);
      if (+this.whichPage < 1) {
        this.whichPage = 1;
      }
      if (+this.whichPage > this.totalPages) {
        this.whichPage = this.totalPages;
      }
      this.currentPage = +this.whichPage;
      this.getSpliceKnowledge();
    },

    goToVisualiztion(genename, astype, coordinate) {
      this.$router.push({
        path: '/splicevis',
        query: {
          genename: genename,
          astype: astype,
          coordinate: coordinate
        }
        // NavigationDuplicated: Avoided redundant navigation to current location
        // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToDetails(eventid, cancername, pubmedid) {
      this.$router.push({
        path: '/browse/knowledge/details',
        query: {
          eventid: eventid,
          cancername: cancername,
          pubmedid: pubmedid
        }
        // NavigationDuplicated: Avoided redundant navigation to current location
        // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToRegulationNetwork(genename) {
      let regulator = genename;
      if (regulator) {
        this.$router.push({
          path: '/tools/regnet',
          query: {
            regulator: regulator,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (regulator == null || regulator == '') {
        window.alert("Sorry, Gene cannot be null.")
      }
    },
    goToRegulationExplorer(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/regexp',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/survival/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToStaging(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/stage/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Gene Name', 'Cancer Type', 'AS Type',
        'ORF', 'Mechanism', 'Function', 'PubMed', 'Visualization',
        'Network', 'Explorer', 'Survival', 'Staging', 'Details'];
    },
  },
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

// .v-sheet.v-card
//   border-radius: 15px

.v-card__title
  line-height: 0.5rem

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.pagesize-select
  max-width: 8%

.jump-select
  max-width: 8%

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>